import React, { Component } from "react";
import { storage, db } from '../../firebase/index';
// import { Redirect } from 'react-router-dom';

class UploadForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      image: null,
      urlUpload: false,
      url: '',
      name: '',
      host: '',
      // redirect: false
    }
  }
  shouldComponentUpdate(nextProps, nextState){
    const oldImage = this.state.image;
    const newImage = nextState.image;
    const urlUpload = this.state.urlUpload;
    if (oldImage === newImage && urlUpload === true) {
      return false;
    }

    return true;
  }
  componentDidUpdate(prevProps, prevState){
    const oldImage = prevState.image;
    const newImage = this.state.image;
    if (oldImage !== newImage) {
      this.handleImageUpload();
    }
  }


  handleImageChange = (e) => {
    if (e.target.files[0]) {
      const image = e.target.files[0];
      this.setState(() => ({image}));
    }
  }
  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value
    });
  }
  handleImageUpload = () => {
    const {image} = this.state;
    // Create a storage ref
    const uploadTask = storage.ref(`booth/${image.name}`).put(image)
    uploadTask.on('state_changed', 
    (snapshot) => {
      // progress function
    }, 
    (error) => {
      // error function
    },
    () => {
      // complete function
      storage.ref('booth').child(image.name).getDownloadURL().then((url) => {
        this.setState({
          url: url,
          urlUpload: true
        });
      })
    });
  }
  handleUpload = () => {
    const { url, name, host } = this.state;
    const info = {
      url: url,
      name: name,
      host: host
    }
    // const setRedirect = this.setRedirect;
    db.collection("Booth").add(info)
    .then(function(docRef) {
        console.log("Document written with ID: ", docRef.id);
        // setRedirect();
        window.history.back();      // TODO: 수정해야됨
    })
    .catch(function(error) {
        console.error("Error adding document: ", error);
    });
  }
  // setRedirect = () => {
  //   this.setState({
  //     redirect: true
  //   });
  // }
  // renderRedirect = () => {
  //   if (this.state.redirect) {
  //     return <Redirect to='/' />
  //   }
  // }
  clickFileUpload = (e) => {
    const input_img = document.getElementsByClassName('input-img')[0];
    console.log(input_img);
    input_img.click();
  }  

  render(){
    // const { image, url, name, host } = this.state;
    const btnClass = this.state.urlUpload && this.state.name!=='' && this.state.host!=='' ? 'clickable' : '';
    ;
    return(
      <div className="upload-form">
        <div className="field"><input type="text" onChange={this.handleChange} name="name" placeholder="대상" /></div>
        <div className="field"><input type="text" onChange={this.handleChange} name="host" placeholder="개최자" /></div>
        <div className="field hidden"><input type="file" accept="image/*" className="input-img" onChange={this.handleImageChange} alt="upload image"/></div>
        <img src={this.state.url || 'https://via.placeholder.com/150'} alt="uploaded images" height="200px" onClick={this.clickFileUpload} />
        <div className={`button-container ${btnClass}`}><button className={`${btnClass}`} onClick={this.handleUpload}>Upload</button></div>
        {/* {this.renderRedirect()} */}
        <br />
        {this.state.urlUpload && this.state.name && this.state.host ? this.btnClickable : null}
        <div className="">
          
        </div>
      </div>
    );
  }
}
export default UploadForm;